import { toast } from "react-toastify";
import { useMemo, useState } from "react";
import I18n from "common/i18n";
import { DeleteMessageBox } from "common/elements";
import { MOCK_TRASH_PIECES } from "features/builder/mockData";
import { MapCard, TrashMapsHeader } from "features/builder/elements";
import {
  MockPiece,
  PieceListContext,
  PieceCardAction,
  PieceSortOrder,
} from "features/builder/pieceList";

export const TrashMapsTab = () => {
  const [pieces, setPieces] = useState<MockPiece[]>(MOCK_TRASH_PIECES);
  const [sortOrder, setSortOrder] = useState<PieceSortOrder>(PieceSortOrder.DESC);
  const [deleteTarget, setDeleteTarget] = useState<MockPiece | null>(null);

  const visibleMaps = useMemo(() => {
    const list = [...pieces];
    list.sort((a, b) => {
      const av = a.deleted_at ?? "";
      const bv = b.deleted_at ?? "";
      return sortOrder === PieceSortOrder.DESC ? bv.localeCompare(av) : av.localeCompare(bv);
    });
    return list;
  }, [pieces, sortOrder]);

  const handleAction = (piece: MockPiece) => (action: PieceCardAction) => {
    switch (action) {
      case PieceCardAction.RESTORE:
        setPieces((prev) => prev.filter((m) => m.piece_id !== piece.piece_id));
        toast(I18n.t("MSG_BUILDER_TRASH_RESTORE_TOAST"));
        break;
      case PieceCardAction.DELETE_FOREVER:
        setDeleteTarget(piece);
        break;
      default:
        break;
    }
  };

  const handleConfirmDelete = () => {
    if (!deleteTarget) return;
    setPieces((prev) => prev.filter((m) => m.piece_id !== deleteTarget.piece_id));
    setDeleteTarget(null);
    toast(I18n.t("MSG_BUILDER_TRASH_DELETE_TOAST"));
  };

  return (
    <div className="flex-col-el relative w-full h-full p-4 gap-3">
      <TrashMapsHeader
        count={visibleMaps.length}
        onToggleSort={() =>
          setSortOrder((o) =>
            o === PieceSortOrder.DESC ? PieceSortOrder.ASC : PieceSortOrder.DESC,
          )
        }
      />

      <div className="flex-col-el flex-1 w-full overflow-y-auto invisible-scrollbar">
        <div className="flex-row-el flex-wrap items-start justify-start gap-4 pb-4">
          {visibleMaps.map((m) => (
            <MapCard
              key={m.piece_id}
              piece={m}
              context={PieceListContext.TRASH}
              onAction={handleAction(m)}
            />
          ))}
        </div>
      </div>

      <DeleteMessageBox
        visible={deleteTarget != null}
        title={I18n.t("MSG_BUILDER_TRASH_DELETE_CONFIRM_TITLE")}
        message={
          deleteTarget
            ? I18n.t("MSG_BUILDER_TRASH_DELETE_CONFIRM_MSG", { name: deleteTarget.name })
            : ""
        }
        close={() => setDeleteTarget(null)}
        handleDelete={handleConfirmDelete}
      />
    </div>
  );
};
